import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import styles from "./gallery.module.css";

const galleryConfig = {
  studio: {
    folderId: "1OQoaDl9kb7VEAYF1m4HHkble-j_FWJs7",
    quote: "There is a role and function for ",
    highlight: "beauty in our time",
    author: "— Tadao Ando",
  },
  moments: {
    folderId: "1UigUDpDj_SbZ0lgIEWSdii0CYUiE5JWe",
    quote: "Limitation of resources leads us to ",
    highlight: "unusual inventiveness.",
    author: "— B.V Doshi",
  },
  progress: {
    folderId: "19RSSlEzNmcXmzlNbg192mxuPklzdM5Kq",
    quote:
      "Light creates ambience and feel of a place, as well as the ",
    highlight: "expression of a structure.",
    author: "— Le Corbusier",
  },
};

const CollapsibleGallery = () => {
  const [expanded, setExpanded] = useState(false);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const routeKey = location.pathname.split("/")[1];
  const currentConfig = galleryConfig[routeKey];
  const isGalleryPage = routeKey === "studio";

  /* ✅ HOOK ALWAYS RUNS */
  useEffect(() => {
    if (!isGalleryPage || !currentConfig) return;

    const fetchImages = async () => {
      try {
        setLoading(true);

        const apiKey =
          "AIzaSyAAgFvKs3Vo5nuo_bkIY1ePkNqNsSmB33g";
        const folderId = currentConfig.folderId;

        const url = `https://www.googleapis.com/drive/v3/files?q='${folderId}' in parents and mimeType contains 'image/'&fields=files(id,name)&key=${apiKey}`;

        const response = await axios.get(url);

        const imageFiles = response.data.files.map((file) => ({
          id: file.id,
          name: file.name,
          url: `https://drive.google.com/thumbnail?id=${file.id}&sz=w2000`,
        }));

        setImages(imageFiles);
      } catch (err) {
        console.error("Failed to fetch images", err);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, [currentConfig, isGalleryPage]);

  const centerIndex =
    images.length > 0 ? Math.floor(images.length / 2) : null;

  if (!currentConfig) {
    return null;
  }

  return (
    <div className={styles.container}>
      {/* HEADER */}
      <div className={styles.headerRow}>
        <div className={styles.left}>
          <p className={styles.desc}>
            “{currentConfig.quote}
            <strong>{currentConfig.highlight}</strong>”
            <span className={styles.subText}>
              {currentConfig.author}
            </span>
          </p>
        </div>

        {/* BUTTON ONLY FOR GALLERY */}
        {isGalleryPage && (
          <button
            type="button"
            className={styles.toggleBtn}
            onClick={(e) => {
              e.preventDefault();
              setExpanded((p) => !p);
            }}
          >
            {expanded ? "Collapse" : "Expand"}
          </button>
        )}
      </div>

      {/* GALLERY ONLY FOR GALLERY PAGE */}
      {isGalleryPage && (
        <div
          className={`${styles.galleryWrapper} ${expanded ? styles.show : ""
            }`}
        >
          {loading ? (
            <p className={styles.loading}>Loading images...</p>
          ) : (
            <div className={styles.gallery}>
              {images.map((img, index) => (
                <img
                  key={img.id}
                  src={img.url}
                  alt={img.name}
                  className={`${styles.img} ${expanded && index === centerIndex
                      ? styles.centerExpanded
                      : ""
                    }`}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CollapsibleGallery;
